export const formatLoadStatus = (status: string | null | undefined): string => {
  return status || 'Unknown';
};
